import { Typography } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing'
import LaceworkCredentialsForm from './LaceworkCredentialsForm'
import LaceworkMappingForm from './LaceworkMappingForm'
import { columnRenderArrayData, CellRenderers } from 'utils/tableUtils'

export default function LaceworkConfigListing(props) {

    const [extraLoginConfigFields,setExtraLoginConfigFields] = useState([]);

    useEffect(()=>{
        if(props.loginConfigList && props.loginConfigList.length){
            const value = props.loginConfigList.map((login)=> {
                const {roleArn,region,bucketName,externalId} = login;
                return(<>
                  {roleArn && <Typography.Text className="m-r-l">Role: {roleArn}</Typography.Text>}
                  {region && bucketName && <Typography.Text className="m-r-l">Region: {region}</Typography.Text>}
                  {bucketName && <Typography.Text className="m-r-l">S3 Bucket Name: {bucketName}</Typography.Text>}
                  {externalId && <Typography.Text className="m-r-l">External Id: {externalId}</Typography.Text>}
              </>)
            })
            setExtraLoginConfigFields(value);
        }
    },[props.loginConfigList]);

    const extraColumns = useMemo(() => [{
        dataIndex: "cloudAccountName",
        title: "Cloud Account Name",
        width: 150,
        render: (cloudAccount) => cloudAccount ? columnRenderArrayData(cloudAccount) : "All",
    },
    {
        dataIndex: "cloudRegistryName",
        title: "Container Registry (Account/Container Registry)",
        width: 150,
        render: (cloudRegistryName) => cloudRegistryName ? columnRenderArrayData(cloudRegistryName) : "All",
    }, 
    {
        dataIndex: "machineTagKey",
        title: "Machine Tag Key",
        width: 150
    }, 
    {
        dataIndex: "machineTagValue",
        title: "Machine Tag Value",
        width: 150
    }, 
    {
        dataIndex: "podNamespace",
        title: "Namespace",
        width: 150,
        render: (podNamespace, record) => record.containerIntegrationType === "registry" ? CellRenderers.VALUE_OR_NA() : podNamespace && podNamespace !== "All" ? columnRenderArrayData(podNamespace) : "All",
    },
    {
        dataIndex: "containerRegistryName",
        title: "Container Registry (Container)",
        width: 150,
        render: (containerRegistryName, record) => record.containerIntegrationType === "namespace" ? CellRenderers.VALUE_OR_NA() : containerRegistryName ? columnRenderArrayData(containerRegistryName) : "All",
    }
    ],
    [])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            extraLoginConfigFields={extraLoginConfigFields}
            MappingForm={LaceworkMappingForm}
            CredentialsForm={LaceworkCredentialsForm}
            extraColumns={extraColumns}
            triggerModifyParam={triggerModifyParam}
        />
    )
};

const triggerModifyParam = (record) => {
    return {
        toolConfigId: record.id
    }
}